import React from 'react'
import { Page } from '../../components/page'
import Recover from '../../blocks/recover'

export default () => (
  <Page name="RECOVER" title="Reset your password">
    <Recover />
  </Page>
)
